<template>
  <div>
    <div>
      <button v-status="meta.permission_prefix + 'edit'"
              class="btn btn-edit btn-sm m-1" @click="action(data, 'edit')"><i class="fa fa-pencil-alt"></i></button>

      <button v-status="meta.permission_prefix + 'delete'"
              class="btn btn-delete btn-sm m-1" @click="action(data, 'delete')"><i class="fa fa-trash"></i></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contentBtnAction',

  props: {
    data: Object,
    action: Function,
    meta: Object
  }
}
</script>
